<script setup lang="ts">
import { PropType, computed } from 'vue';
import AppFormInputBase from './app-form-input-base.vue';
import inputeTextPreset from '@/presets/customizations/inputtext';

defineEmits(['right-button-click']);
const modelValue = defineModel<string | null>();

const props = defineProps({
  label: {
    type: String,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
  },
  icon: {
    type: String,
  },
  width: {
    type: Number,
  },
  errors: {
    type: Object as PropType<{ _errors: string[] }>,
  },
  useRightButton: {
    type: Boolean,
  },
  rightButtonIcon: {
    type: String,
    default: 'hugeicons:pencil-edit-01',
  },
  limitWidth: {
    type: Boolean,
    default: true,
  },
  isRequired: {
    type: Boolean,
  },
});

const style = computed(() => {
  return {
    width: props.width ? props.width + 'px' : 'unset',
  };
});
</script>

<template>
  <app-form-input-base
    :label="props.label"
    :errors="props.errors"
    :limit-width="props.limitWidth"
    :is-required="props.isRequired"
  >
    <template #default="{ id }">
      <slot>
        <i
          :class="props.icon"
          class="absolute flex-none top-2/4 mt-2 left-3 text-surface-400 dark:text-surface-600"
          v-if="!!props.icon"
        />
        <InputGroup>
          <InputText
            :id="id"
            :class="{ 'pl-10': !!props.icon }"
            class="!w-full !py-2 text-[15px]"
            v-model="modelValue"
            :placeholder="props.placeholder"
            :style="style"
            :readonly="props.readonly"
            :disabled="props.disabled"
            :invalid="!!props.errors?._errors?.length"
            :ptOptions="{ mergeSections: true, mergeProps: true }"
            :pt="inputeTextPreset"
          />
          <Button
            size="small"
            :icon="props.rightButtonIcon"
            v-if="props.useRightButton"
            @click="$emit('right-button-click')"
            :ptOptions="{ mergeSections: true, mergeProps: true }"
            :pt="{
              root: '!py-2',
            }"
          />
        </InputGroup>
      </slot>
    </template>
  </app-form-input-base>
</template>
